import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

export default function Login() {
  const { login, error } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    const ok = await login(email, password);
    setBusy(false);
    if (ok) { toast.success("Welcome back"); nav("/browse"); }
  };

  return (
    <div className="min-h-[calc(100vh-64px)] grid lg:grid-cols-2">
      <div className="hidden lg:block relative border-r border-neutral-200 bg-neutral-50">
        <div className="absolute inset-0 grid-bg opacity-40"/>
        <div className="relative p-12 h-full flex flex-col justify-between">
          <div className="font-display font-medium text-3xl tracking-tight max-w-md">
            "I book a den three blocks away every Tuesday. My apartment is finally quiet again."
          </div>
          <div className="text-sm text-neutral-500">— Milo Fenwick, guest since 2025</div>
        </div>
      </div>
      <div className="flex items-center justify-center p-8">
        <form onSubmit={submit} className="w-full max-w-sm space-y-5">
          <div>
            <div className="label-eyebrow mb-2">Welcome back</div>
            <h1 className="font-display font-medium text-3xl tracking-tight">Sign in to DenShare</h1>
          </div>
          <div>
            <div className="label-eyebrow mb-1.5">Email</div>
            <Input data-testid="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="h-11 border-neutral-300"/>
          </div>
          <div>
            <div className="label-eyebrow mb-1.5">Password</div>
            <Input data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required className="h-11 border-neutral-300"/>
          </div>
          {error && <div className="text-sm text-red-600" data-testid="login-error">{error}</div>}
          <Button data-testid="login-submit" type="submit" disabled={busy} className="w-full h-11 bg-neutral-900 hover:bg-neutral-800 text-white rounded-md">
            {busy ? "Signing in..." : "Sign in"}
          </Button>
          <div className="text-sm text-neutral-500">
            No account? <Link to="/signup" className="underline text-neutral-900">Create one</Link>
          </div>
          <div className="text-xs text-neutral-500 border-t border-neutral-200 pt-4">
            <div className="font-medium text-neutral-700 mb-1">Try the demo</div>
            <div>Guest — guest@denshare.app · guest123</div>
            <div>Host — host@denshare.app · host123</div>
          </div>
        </form>
      </div>
    </div>
  );
}
